<template>
    <div class="py-3 create-user-main-container">
        <div class="d-flex mb-3 title-container">
            <img src="../../../assets/images/title-icon.png" alt="">
            <h3 class="h3">Edit Team</h3>
        </div>
        <div id="createUserContainer" class="tabcontent">
            <form class="form-container row d-flex flex-column justify-content-between">
                <div class="row col-12 inputs-container">
                    <div class="col-md-6">
                        <label class="form-label">Select Entity <span style="color: #E95626">*</span></label>

                        <Multiselect
                                class="designOfAssign"
                                v-model="entity"
                                :options="teams"
                                placeholder="Choose Entity"
                                ref="multiselect3"
                                @change="entityChangeHandler"
                        />
                        <div class="err" v-if="errors['entity'].length > 0">
                            <div v-for="msg in errors['entity']" class="text-danger">{{msg}}</div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label class="form-label">Select Users <span style="color: #E95626">*</span></label>
                        <Multiselect
                                class="designOfAssign"
                                v-model="value"
                                :options="options"
                                placeholder="Choose Users"
                                ref="multiselect"
                                mode="tags"
                                :close-on-select="false"
                                :searchable="true"
                                :create-option="true"
                                @change="selectTeamMember"
                        />
                        <div class="text-danger" v-if="isCorrect">{{errorMessageSelected1}}</div>
                        <div v-if="errors['users'].length > 0">
                            <div v-for="msg in errors['users']" class="text-danger">{{msg}}</div>
                        </div>
                    </div>
                </div>
                <div class="row cssDesignRole col-12">
                    <div class="w-100">
                        <label class="form-label">Select Team Leader <span style="color: #E95626">*</span></label>
                        <Multiselect
                                class="designOfAssign"
                                v-model="leader"
                                :options="options"
                                ref="multiselect2"
                                placeholder="Choose Leader"
                                @change="selectTeamLeader"
                                
                        />
                        <div class="text-danger" v-if="isCorrect">{{errorMessageSelected2}}</div>
                        <div class="err position-absolute" v-if="errors['leader'].length > 0">
                            <div v-for="msg in errors['leader']" class="text-danger">{{msg}}</div>
                        </div>
                    </div>
                </div>
            </form>
            <div v-if="errorMessages.length > 0" class="error-container">
                <div v-for="msg in errorMessages" class="text-danger my-4" >{{msg}}</div>
            </div>
        </div>
        <div class="save-button-container">
            <router-link class="back-route" ref="backBtn" @click="backHandler" :to="this.isDataFlag ? '#':'/settings/teams'">
                <button class="save-button back-btn">Back</button>
            </router-link>
            <button class="save-button" @click.prevent="editTeam" ref="buttonSave">Save</button>
        </div>
    </div>
    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import team from "../../../api-services/team";
    import Multiselect from '@vueform/multiselect';
    import FilePondDemo from '../../components/FilePondDemo';
    import AlartModal from "../../components/AlartModal";
    import changeHandler from '../../../validation/teamValidation';
    import readXlsxFile from 'read-excel-file';
    import SaveBtn from '../../components/SaveBtn';
    import ConfirmationModal from '../../components/ConfirmationModal';
    import {computed} from "vue";

    export default {
        name:'setting-entity-update',
        components:{
            Multiselect,
            FilePondDemo,
            AlartModal,
            SaveBtn,
            ConfirmationModal
        },
        data(){
            return {
                changeHandler,
                teams:[],
                entity:'',
                error:null,
                isFull: false,
                isCorrect:false,
                errorMessageSelected1:null,
                errorMessageSelected2:null,
                value: [],
                leader:null,
                options: [],
                errors:{
                    entity:[],
                    leader:[],
                    users:[],
                    isError: false
                },
                ImagePath:'',
                showModal:false,
                message:null,
                errorMessage:null,
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    users: false,
                    entity: false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage),
            }
        },
        async mounted(){
            await this.$store.dispatch('activeTap', 'settings');
            await this.$store.dispatch('currentRoute', 'settings/teams');

            this.getTeams();
            this.getUsers();
        },
        methods:{
            async confirmModalHandler  (event)  {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/settings/teams');
                }
            },
            entityChangeHandler(e){
                this.errors['entity'][0] = '';
                this.errors.isError = false;
                if (this.entity){
                    this.isData.entity = true
                }else{
                    this.isData.entity = false
                }

                if ( this.isData.entity ||  this.isData.users) {
                    this.$store.dispatch('setDataFlag', true);
                    // console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    // console.log('no data ==>> ')
                }
            },
            async backHandler() {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if (setDataFlag) {
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                } else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false;
                }
            },
            selectTeamMember(e){
                // console.log(this.leader);
                if(this.leader != null){
                    if(e.includes(this.leader)){
                        // this.$refs.buttonSave.disabled = true;
                        this.$refs.multiselect2.deselect({value:e});
                        // this.isCorrect = true;
                        // this.errorMessageSelected1 = "Please Check Team Leader In Members";

                    }else{
                        this.$refs.buttonSave.style.display = "block";
                        // this.$refs.buttonSave.disabled = false;
                        this.isCorrect = false;
                        // this.errorMessageSelected1 = "";
                    }
                }else{
                    // console.log('no similar');
                }

            },
            selectTeamLeader(e){
                this.errors['leader'][0] = '';
                this.errors.isError = false;
                if(this.value.length > 0){
                    if(this.value.includes(e)){
                        // this.$refs.buttonSave.style.display = "none";
                        this.$refs.multiselect.deselect({value:e});
                        // this.isCorrect = true;
                        // this.errorMessageSelected1 = e+" is Team Leader";
                    }else{
                        this.$refs.buttonSave.style.display = "block";
                        this.isCorrect = false;
                        // this.errorMessageSelected1 = "";
                    }
                }else{
                    // console.log('no similar');
                }

            },
            getTeams: async function(){
                let id = this.$route.params.id;
                try {
                    this.entity = id;
                    const response = await team.show(id);
                    for(let i = 0 ; i < response.data.length ; i++){
                        this.$refs.multiselect3.select({value: response.data[i].id , label: response.data[i].name});
                        this.teams.push({label: response.data[i].name, value: response.data[i].id});
                    }

                } catch (e) {
                    // console.log(e);
                    this.error = e;
                }
            },
            getUsers: async function(){
                let editedEntityId = this.$route.params.id;
                try{
                    const response = await team.index('users');
                    const responseSeletcedUsers = await team.show(editedEntityId);
                    // console.log(responseSeletcedUsers);

                    this.$refs.multiselect2.select({value: responseSeletcedUsers.data[0].user.email , label: responseSeletcedUsers.data[0].user.name});
                    this.options.push({value: responseSeletcedUsers.data[0].user.email , label: responseSeletcedUsers.data[0].user.name});

                    for(let i = 0 ; i < response.data.availableUsers.length ; i++){
                        this.options.push({value: response.data.availableUsers[i].email , label: response.data.availableUsers[i].name});
                    }

                    for(let j = 0 ; j < responseSeletcedUsers.data[0].users.length ; j++){
                        this.options.push({value: responseSeletcedUsers.data[0].users[j].email , label: responseSeletcedUsers.data[0].users[j].name});
                        this.$refs.multiselect.select({value: responseSeletcedUsers.data[0].users[j].email , label: responseSeletcedUsers.data[0].users[j].name});
                    }

                }catch(e){
                    // console.log(e);
                    this.error = e;
                }
            },
            async fileRemove(){
                this.value = null;
            },
            async fileUpload(e){
                let newData = [];
                let usersAvailable = [];
                let usersInExcel = [];
                let usersNotInTeams;

                const response = await team.index('users');
                for (let i = 0; i < response.data.availableUsers.length; i++) {
                    usersAvailable.push({value:response.data.availableUsers[i].email , label: response.data.availableUsers[i].name});
                }

                await readXlsxFile(e).then((data) => {
                    data.shift();
                    newData.push(data);
                });

                newData[0].forEach(item => {
                    usersInExcel.push({value: item[1], label: item[0]});
                });


                if(usersAvailable.length > usersInExcel.length){
                    usersNotInTeams = usersAvailable.filter(
                        element => !usersInExcel.includes(element.value)
                    );
                }else{
                    usersNotInTeams = usersInExcel.filter(
                        element => !usersAvailable.includes(element.value)
                    );
                }


                if(usersNotInTeams.length > 0){
                    usersNotInTeams.forEach(item => {
                        let res1 = /\S+@\S+\.\S+/.test(item['value']);
                        let res2 = /^[a-zA-Z()_ \-\[\]'\\|,.\/]*$/.test(item['label']);
                        if (!res1 || !res2) {
                            this.showErrorModal = true;
                            this.errorMessage = 'Please Check Excel Emails Or Names';
                            this.$refs.multiselect.remove();
                        }else{
                            this.options.push({value: item['value'] , label: item['label']});
                        }
                    });
                }else{
                    this.showModal = true;
                    this.ImagePath = 'close.png';
                    this.message = 'No Users Available To Assign To Teams';
                }

                if(usersNotInTeams.length > 0){
                    this.isData.users = true;
                }else{
                    this.isData.users = false;
                }

                if ( this.isData.entity ||  this.isData.users) {
                    this.$store.dispatch('setDataFlag', true);
                    // console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    // console.log('no data ==>> ')
                }

                this.$refs.multiselect.$el.focus();
                this.$refs.multiselect2.$el.focus();

            },
            editTeam: async function(){
                try{
                    if (this.entity === '' || this.entity === null) {
                        this.errors.isError = true;
                        this.errors['entity'][0] = '*Required';
                    }

                    if (this.entity === '' || this.leader === null) {
                        this.errors.isError = true;
                        this.errors['leader'][0] = '*Required';
                    }

                    if(!this.errors.isError){
                        const response = await team.update(this.entity, {users:this.value,leader:this.leader});

                        if(response.status === 200){
                            this.showModal = true;
                            this.ImagePath = 'okImage.svg';
                            this.message = response.data.message;
                            await this.$store.dispatch('setDataFlag', false);
                            setTimeout(() => {
                                this.$router.push({name: 'entity'});
                            } , 3000);
                        }else{
                            // console.log('Something Wrong !');
                        }
                    }


                }catch(e){
                    if(e.response.data.errors){
                        if(e.response.data.errors.users){
                            if(e.response.data.errors.users)
                                e.response.data.errors.users.forEach((err,idx) => {this.errors['users'][idx] = `* ${err}`});
                        }else{
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                let record = property.split('.')[0];
                                this.errors['users'][idx++] = `* record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                            }
                        }
                    }else if(e.response.data){
                        this.showErrorModal = true;
                        this.message = e.response.data.message;
                    }
                }
            }
        }
    }
</script>

<style scoped>

.back-btn{
    background-color: #707070 !important;
    
}
.title-container{
    align-items: center;
    margin-bottom: 2% !important;
}
.title-container img{
    margin-bottom:0;
    padding-right: 10px;
}

.text-danger{
    font-size: 13px;
}
.create-user-main-container{
    padding-inline: 40px;
}

.title-container .h3{
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom:0;
    font-size: calc(1rem+0.5vw);
}
#createUserContainer{
    border: 1px solid var(--table-color-data);
    background-color: var(--table-color-data);
    padding: 23px 0 23px 23px !important;
    border-radius: 15px;
    height: auto;
    overflow-y: unset;

}
label{
        font-weight: 600;
}
input,
input::placeholder,
.designOfAssign,
.designOfAssign :deep(.multiselect-placeholder)
{
    background-color: var(--input-background);
    color: var(--input-color) !important;
    font-weight: normal;
    font-size: 13px;
    font-style: italic;
    opacity:1 !important;
}
.input-group-text {
    margin-left: 10px;
    height: 38px;
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    font-size: 12px;
}

.cssGap {
    gap: 20px;
}

/* .cssDesignRole {
    position: relative;
    right: 16px;
} */

.hrAll {
    display: flex;
    width: 97%;
}

.textH5 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.designOfAssign {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    
    width: 100%;
}

.err {
    overflow-y: auto;
    min-height: 30px;
    max-height: 170px;
}

.custom-input,
.custom-input:focus,
.form-control {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
}
.multiselect-caret{
    background-color: #848484 !important;
}




.upload-file {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
    display: flex;
}

.upload-file2 {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
}

.form-container {
    gap: 20px;
}

.error-container {
    max-height: 250px;
    min-height: 10px;
    height: 90px;
    padding: 10px;
    margin-top: 40px;
    overflow-y: auto;
}

.inputs-container {
    height: 80px;
}
.save-button{
    border: none;
    color: #fff;
    background-color: var(--btn-bg-color);
    padding: 0px 50px;
    border-radius: 5px;
    font-weight: normal;
    font-size: 18px;
    height: 100%;
}
.back-route{
    margin-right: 10px;
    font-size: 18px;
}
.save-button-container{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width: 100%;
        height: 35px;
}
</style>

